// Универсальный логгер.
// В dev-режиме выводит в консоль как обычный console, в production — молчит
// для info/log/debug, но пропускает warn/error (чтобы критичные проблемы
// были видны в DevTools техподдержки и в Sentry, если подключим позже).
//
// Использование:
//   import logger from '../utils/logger';
//   logger.log('загружен профиль', profile);
//   logger.error('не удалось загрузить', err);
//
// Почему важно: голые console.log утекают в продакшен — видны имена, email,
// токены, тела ответов API. Это и шум, и слив данных. Logger даёт единую
// точку: в одном месте можно отключить вывод / подключить Sentry / навесить
// прокси на ошибки.

const isDev = process.env.NODE_ENV !== 'production';

// Опциональный обработчик ошибок — сюда можно прикрутить Sentry или другую
// телеметрию, когда подключим. Пока что в проде только пишем в консоль.
let externalErrorHandler = null;

export function setErrorHandler(fn) {
    externalErrorHandler = fn;
}

const logger = {
    log: (...args) => { if (isDev) console.log(...args); },
    info: (...args) => { if (isDev) console.info(...args); },
    debug: (...args) => { if (isDev) console.debug(...args); },

    // warn/error пропускаем всегда — это сигнал о реальных проблемах.
    warn: (...args) => { console.warn(...args); },
    error: (...args) => {
        console.error(...args);
        if (externalErrorHandler) {
            try { externalErrorHandler(...args); } catch (_) { /* не падаем из-за хендлера */ }
        }
    },
};

export default logger;
